/** **************************** Export Login Types ****************************** */
export const UPDATE_TIMELINE_SUCCESS = "UPDATE_TIMELINE_SUCCESS";
export const UPDATE_TIMELINE_FAILURE = "UPDATE_TIMELINE_FAILURE";
export const UPDATE_TIMELINE_REQUEST = "UPDATE_TIMELINE_REQUEST";
